import { EventNames, dispatchEvent } from "../../portalEvents";

export enum NotificationType {
    Default,
    Info,
    Success,
    Warning,
    Error,
}

export interface IData {
    type: NotificationType;
    messages: string[];
}

// @deprecated Use Snackbar from Components Library
export function info(message: string | string[], ...rest: string[]) {
    const data: IData = { type: NotificationType.Info, messages: createMessageArray(message, ...rest) };
    dispatchEvent(EventNames.NotificationSent, data);
}

// @deprecated Use Snackbar from Components Library
export function warn(message: string | string[], ...rest: string[]) {
    const data: IData = { type: NotificationType.Warning, messages: createMessageArray(message, ...rest) };
    dispatchEvent(EventNames.NotificationSent, data);
}

// @deprecated Use Snackbar from Components Library
export function error(message: string | string[], ...rest: string[]) {
    const data: IData = { type: NotificationType.Error, messages: createMessageArray(message, ...rest) };
    dispatchEvent(EventNames.NotificationSent, data);
}

// @deprecated Use Snackbar from Components Library
export function success(message: string | string[], ...rest: string[]) {
    const data: IData = { type: NotificationType.Success, messages: createMessageArray(message, ...rest) };
    dispatchEvent(EventNames.NotificationSent, data);
}

const createMessageArray = (message: string | string[], ...rest: string[]): string[] =>
    message instanceof Array ? [...message, ...rest] : [message, ...rest];
